import { associatePerformanceService } from 'config/api';
import actionTypes from './actionTypes';
import { adjustPerformanceParams } from '../utils';

export const getTransactionDetailsV2 = (associatePin, options = {}) => async (dispatch) => {
  dispatch({
    type: actionTypes.TRANSACTION_DETAILS_V2_LOADING,
  });

  const params = adjustPerformanceParams(options);

  try {
    const {
      data: { items, count },
    } = await associatePerformanceService.post(`/v2/data/${associatePin}/associateOrderItems`, params);

    dispatch({ type: actionTypes.TRANSACTION_DETAILS_V2_SUCCESS, payload: { items, count } });
  } catch (error) {
    dispatch({ type: actionTypes.TRANSACTION_DETAILS_V2_ERROR, payload: error });
  }
};

export const resetTransactionDetails = () => ({
  type: actionTypes.RESET_TRANSACTION_DETAILS,
});
